// extracted by mini-css-extract-plugin
export default {"container":"Container_container__T6j24","centered":"Container_centered__VJlYd"};